<template>
    <v-card link flat :class="item.Active ? '' : 'deactivated'" class="rounded-0" tabindex="-1" @click="$emit('click')">
        <v-row no-gutters class="px-3 py-2" align="center">
            <v-col cols="auto" class="pr-3" style="opacity: 0.7">
                {{ item.Id }}
            </v-col>
            <v-col cols="0">
                {{ item.Name }}
            </v-col>
            <v-col cols="auto" class="d-flex align-center">
                <template v-if="!item.Global">
                    <v-icon size="15" :color="item.LinkedCount ? '' : 'disabled'" style="margin-right: 2px;">
                        $machine_categories
                    </v-icon>
                    <p :class="item.LinkedCount ? '' : 'disabled--text'" class="ma-0">
                        {{ item.LinkedCount }}
                    </p>
                </template>
                <template v-else>
                   <v-icon v-text="item.Global ? 'mdi-earth' : 'mdi-earth-off'"
                        :color="item.Global ? 'warning' : 'disabled'" size="20" class="mr-1">
                    </v-icon>
                </template>
            </v-col>
        </v-row>
    </v-card>
</template>


<script>
export default {
    name: 'CounterListItem',
    props: {
        item: Object,
    },
    components: {},

    data() {
        return {};
    },

    methods: {},

    computed: {},

    watch: {},
};
</script>


<style lang='scss'>
.deactivated {
    background-color: var(--v-disabled-lighten1) !important;
}

.deactivated:not(:hover) div div {
    color: var(--v-disabled-darken2) !important;
    text-decoration: line-through !important;
}
</style>